'use client';

import React from 'react';
import { SwiperSlide } from 'swiper/react';
import OngoingCampaignCard from '../Card/OngoingCampaignCard';
import SliderWrapper from '../Wrapper/SliderWrapper';
import OngoingCampaignSkeleton from '../Skeleton/OngoingCampaignSkeleton';

// swiper slider
import 'swiper/css';
import 'swiper/css/scrollbar';
import './custom_scrollbar.css';

function OngoingCampaignSlider({ data, sectionData, loading = false }) {
  if (data.length === 0) {
    return null;
  }

  const renderContent = () => {
    if (loading) {
      return (
        <SwiperSlide className="max-w-max">
          <OngoingCampaignSkeleton />
        </SwiperSlide>
      );
    }

    return data?.map((item, index) => (
      <SwiperSlide key={item?.id ?? index} className="max-w-max">
        <OngoingCampaignCard
          item={item}
          imageSrc={item?.image_1x1}
          alt={item?.title?.en}
          title={item?.title?.en}
          url={item?.url}
          sectionData={sectionData}
        />
      </SwiperSlide>
    ));
  };

  return <SliderWrapper data={data}>{renderContent()}</SliderWrapper>;
}

export default OngoingCampaignSlider;
